module.exports = __webpack_public_path__ + "img/1440.1b61b2cc.jpg";